import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { QRCodeModule } from 'angularx-qrcode';
import { ColorThemingDirective } from '../core/directives/color-theming.directive';

import {
    FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { MatStepperModule } from '@angular/material/stepper';
import {
    MatProgressBarModule
} from '@angular/material/progress-bar';
import { AgentCard } from './agent-card/agent-card.component';
import { AgentFooter } from './agent-footer/agent-footer.component';
import { AgentPartnerRow } from './agent-partner-row/agent-partner-row.component';
import { EmailPopup } from './email-popup/email-popup.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ColorPickerModule } from 'ngx-color-picker';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { AgentOnboardingBanner } from './agent-onboarding-banner/agent-onboarding-banner.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { StateDropdownComponent } from './state-dropdown/state-dropdown.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DragDropModule,
        ReactiveFormsModule,
        TranslateModule,
        MatButtonModule,
        MatToolbarModule,
        MatSelectModule,
        MatTabsModule,
        MatStepperModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatCardModule,
        MatDialogModule,
        MatSidenavModule,
        MatCheckboxModule,
        MatListModule,
        MatMenuModule,
        MatAutocompleteModule,
        MatIconModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatPaginatorModule,
        MatDividerModule,
        FontAwesomeModule,
        RouterModule,
        MatButtonToggleModule,
        MatExpansionModule,
        MatDatepickerModule,
        ImageCropperModule,
        ColorPickerModule,
        GooglePlaceModule,
        MatSliderModule,
        MatProgressBarModule,
        FormlyBootstrapModule,
        FormlyModule,
        QRCodeModule,
        CreditCardDirectivesModule,
        NgApexchartsModule,
        MatTableModule,
        ColorThemingDirective,
        MatFormFieldModule,
        MatNativeDateModule
    ],
    declarations: [
        StateDropdownComponent
    ],
    exports: [
        StateDropdownComponent,
    ]
})
export class SharedDropdownModule {
    constructor() {
    }
}
